import { UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler, UIComponentProps } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { ConfirmationViewImpl } from './confirmationview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { ConfirmationCSSStyleImpl } from './confirmationcss';


export interface ConfirmationComponentProps extends UIComponentProps
{
    message: string;
    onClick(): void;
}

export interface ConfirmationComponentHandler extends UIComponentHandler
{
    onLoginNowClick():void;

}
export class ConfirmationComponent extends UIComponentImpl<ConfirmationComponentProps, UIComponentState, UIDataModel> implements ConfirmationComponentHandler
{
    constructor(props: ConfirmationComponentProps)
    {
        super(props);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ConfirmationViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ConfirmationCSSStyleImpl(applicationContext);
    }
   

    onLoginNowClick():void
    {
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/confirmation/confirmationcomponent.tsx